//local
// const API_BASE_URL = `http://localhost:5000/api`;
// const SOCKET_URL = `http://localhost:5000`;

// Caddy serves the app and proxies /api on the same origin, so the API is
// always reachable relative to wherever the page itself was loaded from.
// Keeping these relative to window.location means one build works on any
// host/port (prod, staging, a real domain) - REACT_APP_BASE_URL would be
// baked in at build time and hardcode a single host.
const API_ORIGIN = typeof window !== 'undefined'
  ? window.location.origin
  : `https://${process.env.REACT_APP_BASE_URL}`;
const API_BASE_URL = `${API_ORIGIN}${process.env.REACT_APP_REST_API_BASE_PATH}`;
const SOCKET_URL = API_ORIGIN;
const SOCKET_PATH = process.env.REACT_APP_SOCKET_API_BASE_PATH;
const FILES_BASE_URL = process.env.REACT_APP_FILES_BASE_URL
const RECAPTCHA_SITE_KEY = process.env.REACT_APP_SITE_KEY
const lineBreakLimit = 1426;

export { API_BASE_URL, lineBreakLimit, SOCKET_URL, SOCKET_PATH, FILES_BASE_URL, RECAPTCHA_SITE_KEY }


